import React, { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';

const Sentence = ({ sentence, index, correctIndex, moveSentence, submitted }) => {
  const ref = useRef(null);

  const [, drop] = useDrop({
    accept: 'Sentence',
    hover(item) {
      if (!ref.current || submitted) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) {
        return;
      }

      moveSentence(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: 'Sentence',
    item: { id: sentence.id, index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const opacity = isDragging ? 0.4 : 1;

  let backgroundColor = 'bg-green-50';
  if (submitted) {
    backgroundColor = index === correctIndex ? 'bg-green-200' : 'bg-red-200';
  }

  if (!submitted) {
    drag(drop(ref));
  }

  return (
    <div
      ref={ref}
      style={{ opacity }}
      className={`p-2 border border-gray-300 rounded-md cursor-move ${backgroundColor}`}
    >
      {sentence.options}
    </div>
  );
};

export default Sentence;
